import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import SmoothScroll from "./components/SmoothScroll";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (
                <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-paper text-ink px-6 text-center">
                    <p className="font-mono text-xs uppercase tracking-[0.2em]">Errore imprevisto</p>
                    <a href="/" className="border border-ink px-6 py-3 text-sm hover:bg-ink hover:text-paper transition-colors">
                        Torna all'inizio
                    </a>
                </div>
            );
        }
        return this.props.children;
    }
}

function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (!hash) {
            if (window.__lenis) {
                window.__lenis.scrollTo(0, { immediate: true });
            }
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);
    return null;
}

function App() {
    return (
        <ErrorBoundary>
            <BrowserRouter>
                <SmoothScroll />
                <ScrollToTop />
                <div className="min-h-screen bg-paper text-leafdeep font-body antialiased">
                    <div className="grain" aria-hidden="true" />
                    <Header />
                    <main>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/privacy" element={<Privacy />} />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </main>
                    <Footer />
                </div>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
